import { render } from "./DashboardPeriodFilter.vue?vue&type=template&id=6d145fd6&scoped=true"
import script from "./DashboardPeriodFilter.vue?vue&type=script&lang=js"
export * from "./DashboardPeriodFilter.vue?vue&type=script&lang=js"

import "./DashboardPeriodFilter.vue?vue&type=style&index=0&id=6d145fd6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d145fd6"]])

export default __exports__